<template>
  <div>
    <proficient v-if="!isLoading" :proficient="proficient" />
    <b-spinner v-else variant="primary" label="Loading..." />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Proficient } from '@/components/KudosList'

export default {
  name: 'KudoProficient',

  props: {
    kudo: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters([
      'kudoProficient',
      'isKudoProficientLoading'
    ]),

    isLoading() {
      return this.isKudoProficientLoading(this.kudo.id)
    },

    proficient() {
      return this.kudoProficient(this.kudo.id)
    }
  },

  mounted() {
    this.$store.dispatch('fetchKudoProficientIfNot', this.kudo.id)
  },

  components: {
    Proficient
  }
}
</script>
